[
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/abs-autoherstel.png",
    "images": {"xs": {"uri": "/partners/abs-autoherstel.png", "width": 180, "height": 89}}
  },
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/legal-shared.png",
    "images": {"xs": {"uri": "/partners/legal-shared.png", "width": 119, "height": 66}}
  },
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/hersteldirect.png",
    "images": {"xs": {"uri": "/partners/hersteldirect.png", "width": 132, "height": 36}}
  },
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/carglass.png",
    "images": {"xs": {"uri": "/partners/carglass.png", "width": 137, "height": 137}}
  },
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/smartphort.jpg",
    "images": {"xs": {"uri": "/partners/smartphort.jpg", "width": 200, "height": 150}}
  },
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/eurocross-assistance.jpg",
    "images": {"xs": {"uri": "/partners/eurocross-assistance.jpg", "width": 75, "height": 75}}
  },
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/autotaalglas.jpg",
    "images": {"xs": {"uri": "/partners/autotaalglas.jpg", "width": 75, "height": 75}}
  },
  {
    "date": "2018-10-12T13:19:00+01:00",
    "image": "/partners/uniglas.png",
    "images": {"xs": {"uri": "/partners/uniglas.png", "width": 205, "height": 170}}
  }
]